export default __webpack_public_path__ + "static/media/1984.7b55b0eb.png";